import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import {deviceMax} from '../../theme/breakpoints'
import Filter from '../../images/icons/filter.svg'
import Refresh from '../../images/icons/refresh.svg'
import Heading from '../Heading/Heading'
import SelectComponent from '../Select/Select'
import Arrow from '../../images/icons/arrow-right.svg'
import Button from '../Button/Button'

export const StyledModal = styled.div`
  visibility: ${({$showFilters}) => ($showFilters ? 'visible' : 'hidden')};
  z-index: 55;
  @media ${deviceMax.mobileL} {
    position: fixed;
    top: 0;
    left: 0;
    justify-content: center;
    align-items: center;
    display: flex;
    width: 100%;
    height: 100%;
    background-color: ${({theme}) => theme.colors.opacity.black80};
  }
`

export const StyledArrow = styled(Arrow)`
  transform: rotate(180deg);
`

export const StyledFilter = styled.div`
  width: 100%;
  background-color: ${({theme}) => theme.colors.unique.black};
  align-items: center;
  display: flex;
  justify-content: center;
  @media ${deviceMax.tablet} {
    width: 100%;
  }
`

export const StyledFilterTitle = styled.div`
  cursor: pointer;
  font-weight: ${({theme}) => theme.fonts.weight.bold};
  font-size: ${({theme}) => theme.fonts.sizes.button};
  line-height: ${({theme}) => theme.fonts.lineHeight.button};
  color: ${({theme}) => theme.colors.unique.black};
  width: calc(100% - ${pxToRem(20)});
  background-color: ${({theme}) => theme.colors.unique.white};
  align-items: center;
  display: flex;
  justify-content: center;
  margin: ${pxToRem(20)} 0;
  padding: ${pxToRem(15)};
  border-radius: ${pxToRem(5)};
  @media ${deviceMax.tablet} {
    margin-bottom: 0;
    width: 100%;
  }
`

export const StyledFilterIcon = styled(Filter)``

export const StyledFilterMain = styled.div`
  display: flex;
  @media ${deviceMax.tablet} {
    display: ${({isTablet}) => (isTablet ? 'flex' : 'none')};
  }
`

export const StyledLeftCard = styled.div`
  background-color: ${({theme}) => theme.colors.unique.white};
  padding: ${pxToRem(20)};
  border-radius: ${pxToRem(5)};
`
export const StyledSelect = styled(SelectComponent)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  display: flex;
  width: ${pxToRem(344)};
  border: none;
  border-radius: ${pxToRem(5)};
  margin: ${pxToRem(10)} 0;
  cursor: pointer;

  .react-select__control {
    background-color: ${({theme}) => theme.colors.secondary.grey95};
    border-width: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: ${pxToRem(2)} 0;
  }

  .react-select__indicator-separator {
    width: 0;
  }

  @media ${deviceMax.mobileS} {
    max-width: ${pxToRem(300)}
  }
`
export const StyledCheckBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  margin: ${pxToRem(20)} 0;
`
export const StyledInput = styled.input`
  margin-right: ${pxToRem(10)};
  cursor: pointer;
`
export const StyledLabel = styled.label`
  font-weight: ${({theme}) => theme.fonts.weight.semibold};
`

export const StyledHeading = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const StyledTitle = styled(Heading)``

export const StyledRefresh = styled(Refresh)`
  margin-left: ${pxToRem(10)};
`

export const StyledButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

export const StyledOption = styled.option`
  background-color: ${({theme}) => theme.colors.primary.white};
`

export const StyledShowButton = styled(Button)``

export const StyledBodyButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: ${pxToRem(10)};
`
